import { Controller } from "@hotwired/stimulus"

// Copies a value; with a copiedLabel the control reads that label for two
// seconds after the write succeeds, and failedLabel when the clipboard
// refuses (permission denied, insecure context), so a pill never says
// "Copied" for a value that is not on the clipboard.
export default class ClipboardController extends Controller {
  static values = { content: String, copiedLabel: String, failedLabel: { type: String, default: "Copy failed" } }

  async copy() {
    let written = true
    try {
      await navigator.clipboard.writeText(this.contentValue)
    } catch {
      written = false
    }
    if (!this.hasCopiedLabelValue) return

    const original = this.original ??= this.element.textContent
    this.element.textContent = written ? this.copiedLabelValue : this.failedLabelValue
    if (written) this.element.setAttribute("aria-pressed", "true")
    else this.element.removeAttribute("aria-pressed")
    clearTimeout(this.timer)
    this.timer = setTimeout(() => {
      this.element.textContent = original
      this.element.removeAttribute("aria-pressed")
    }, 2000)
  }

  disconnect() {
    clearTimeout(this.timer)
  }
}
